import hasOwn from 'lodash/has';
import set from 'lodash/set';
import { combineReducers, createStore } from 'redux';

function form(state = {}, action) {
  switch (action.type) {
    case 'save_fields': {
      const updatedState = {
        ...state,
      };
      Object.keys(action.payload).forEach((key) => {
        const value = action.payload[key];
        if (Array.isArray(value)) {
          set(updatedState, key, value);
        } else if (hasOwn(value, 'name')) {
          set(updatedState, value.name, value);
        } else {
          Object.keys(value).forEach((subKey) => {
            const subVal = value[subKey];
            set(updatedState, subVal.name, subVal);
          });
        }
      });
      return updatedState;
    }
    default:
      return state;
  }
}

export const store = createStore(
  combineReducers({
    form,
  }),
);
